/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): theme.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */


const SelectorID = 'navigationBar'
const scrollClass = 'scroll'
const shadowClass = 'shadow-sm'

class Theme{
    constructor(){
        if( 'undefined' !== document.getElementById(SelectorID)){
            this.scroll();
        }        
    }

    scroll(){
        document.addEventListener("DOMContentLoaded", function(){
            window.addEventListener('scroll', function() {
                var height = document.getElementById(SelectorID).offsetHeight;
                if (window.scrollY > height) {
                    document.getElementById(SelectorID).classList.add(scrollClass);
                    document.getElementById(SelectorID).classList.add(shadowClass);
                } else {
                    document.getElementById(SelectorID).classList.remove(scrollClass);
                    document.getElementById(SelectorID).classList.remove(shadowClass);
                } 
            });
        }); 
    }   

}


new Theme();

export default Theme


  


  

 

 